// @flow

import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import './BusinessStructureDoc.scss';

type BusinessStructureDocProps = {|
  id?: string,
  className?: string,
  children: React.Node,
|};

export const BusinessStructureDoc = ({
  id,
  className,
  children,
}: BusinessStructureDocProps) => {
  return (
    <Box className={classNames('BusinessStructureDoc', className)}>
      {children}
    </Box>
  );
};
